<template>
    <div>
        <GChart
                v-if="show"
                ref="gChart"
                :settings="{packages: ['bar', 'line']}"
                :data="chartData"
                :options="chartOptions"
                :createChart="createChart"
                :events="chartEvents"
                @ready="onChartReady"
        />
        <Row>
            <Table :columns="db_col" :data="db_data" class="comissoes" :loading="loading" v-if="showTable"></Table>
        </Row>
    </div>
</template>

<script>
    const {moment} = require("../helpers/utils.js");
    export default {
        name: "monitoracao-detalhe",
        components: {
            GChart: () => import("vue-google-charts").then(({GChart}) => GChart)
        },
        props: ["id", "date"],
        data() {
            return {
                show: false,
                chartsLib: null,
                options: null,
                type: 'bar',
                chartData: [
                    ['col1', 'col2'],
                ],
                chartEvents: {
                    'select': () => {
                        this.getDetails();
                    }
                },
                result: [],
                showTable: false,
                loading: false,
                db_col: [
                    {
                        title: 'Empresa',
                        key: 'nome_empresa',
                        width: 150,
                    },
                    {
                        title: 'Usuário',
                        key: 'nome_usuario',
                        width: 150,
                    },
                    {
                        title: 'Início',
                        key: 'data_hora_inicio',
                        width: 165,
                        render: (h, params) => {
                            return h('div', `${moment(params.row.data_hora_inicio).format('DD/MM/YYYY h:mm:ss')}`);
                        }
                    },
                    {
                        title: 'Fim',
                        key: 'data_hora_fim',
                        width: 165,
                        render: (h, params) => {
                            return h('div', `${moment(params.row.data_hora_fim).format('DD/MM/YYYY h:mm:ss')}`);
                        }
                    },
                    {
                        title: 'Query',
                        key: 'query'
                    },
                ],
                db_data: []
            }
        },
        computed: {
            chartOptions() {
                if (!this.chartsLib) return null;
                if (this.type == 'bar') {
                    return this.chartsLib.charts.Bar.convertOptions({
                        chart: {
                            title: 'Relatório de Querys',
                        },
                        bars: 'vertical', // Required for Material Bar Charts.
                        hAxis: {format: 'decimal'},
                        height: 200,
                        colors: ['#109618'],
                        backgroundColor: 'transparent',
                        legend: {
                            position: "none"
                        },
                    })
                } else {
                    return this.chartsLib.charts.Line.convertOptions({
                        chart: {
                            title: 'Relatório de Querys',
                        },
                        hAxis: {format: 'decimal'},
                        height: 200,
                        colors: ['#109618'],
                        backgroundColor: 'transparent',
                        legend: {
                            position: "none"
                        },
                    })
                }
            },
            filtroDate() {
                return moment(this.date).format("YYYY-MM-DD");
            }
        },
        methods: {
            createChart(el, google) {
                if (this.type == 'bar') {
                    return new google.charts.Bar(el);
                } else {
                    return new google.charts.Line(el);
                }
            },
            onChartReady(chart, google) {
                this.chartsLib = google;
            },
            porEmpresa() {
                this.type = 'bar';
                const URI = `monitoracao/empresas?date=${this.filtroDate}&page=1`;
                this.$axios.get(URI).then(({data}) => {
                    this.chartData = [['Empresa', 'Quantidade']];
                    this.result = data;
                    data.forEach(({nome_empresa, total}) => {
                        this.chartData.push([nome_empresa, total]);
                    });
                    if (data.length > 0) {
                        this.show = true;
                    }
                }).catch(err => {
                    console.warn(err);
                });
            },
            porPessoa() {
                this.type = 'bar';
                const URI = `monitoracao/pessoas?date=${this.filtroDate}&page=1`;
                this.$axios.get(URI).then(({data}) => {
                    this.result = data;
                    this.chartData = [['Usuário', 'Quantidade', {role: 'annotation'}]];
                    data.forEach(({nome_usuario, total, nome_empresa}) => {
                        this.chartData.push([nome_usuario, total, nome_empresa]);
                    });
                    if (data.length > 0) {
                        this.show = true;
                    }
                }).catch(err => {
                    console.warn(err);
                });
            },
            porHorario() {
                this.type = 'line';
                this.show = true;
                const URI = `monitoracao/horario?date=${this.filtroDate}`;
                this.$axios.get(URI).then(({data}) => {
                    this.result = data;
                    this.chartData = [['Horário', 'Quantidade']];
                    data.forEach(({horario, total}) => {
                        this.chartData.push([moment(horario).format("DD/MM/YYYY h:mm"), total]);
                    });
                    if (data.length > 0) {
                        this.show = true;
                    }
                }).catch(err => {
                    console.warn(err);
                });
            },
            getDetails() {
                const table = this.$refs.gChart.chartObject;
                const selection = table.getSelection()[0];
                if (!selection) return;
                const idx = selection.row;
                let URI;
                if (this.id == 1) {
                    const {id_empresa} = this.result[idx];
                    URI = `monitoracao/db?empresa=${id_empresa}&date=${this.filtroDate}&page=1`;
                } else if (this.id == 2) {
                    const {id_usuario} = this.result[idx];
                    URI = `monitoracao/db?usuario=${id_usuario}&date=${this.filtroDate}&page=1`;
                } else if (this.id == 3) {
                    const {horario} = this.result[idx];
                    URI = `monitoracao/db?horario=${horario}&date=${this.filtroDate}&page=1`;
                } else {
                    return;
                }
                this.loading = true;
                this.$axios.get(URI).then(({data}) => {
                    this.db_data = data;
                    this.showTable = true;
                    this.loading = false;
                }).catch(err => {
                    console.warn(err);
                    this.showTable = false;
                });
            }
        },
        mounted() {
            switch (this.id) {
                case 1:
                    this.porEmpresa();
                    break;
                case 2:
                    this.porPessoa();
                    break;
                case 3:
                    this.porHorario();
                    break;
                default:
                    break;
            }
        }

    }
</script>
